import { gsap } from 'gsap';
function Animate(
  sprite,
  { duration = 1, speed = 1, ease = 'power3.out', type, elementToAnimate, delayValue, isBackground }
) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  if (!isBackground) {
    if (type == 'entry') {
      animation = gsap.from(elementToAnimate, {
        duration: duration,
        pixi: {
          alpha: 0,
        },
        //repeat: 0,
        ease: progress => {
          return 1;
        },
        delay: delayValue,
        stagger: duration / steps,
      });
    } else {
      animation = gsap.to(elementToAnimate, {
        duration: duration,
        pixi: {
          alpha: 0,
        },
        repeat: 0,
        delay: delayValue,
        ease: progress => {
          return 1;
        },
        stagger: duration / steps,
      });
    }
  }
  return animation;
}
export default { Animate };
